import { action } from "satcheljs";

export interface SetShowListPaneActionMessage {
    showListPane: boolean;
}

export const setShowListPane: (showListPane: boolean) => SetShowListPaneActionMessage = action("setShowListPane", function setShowListPane(showListPane: boolean): SetShowListPaneActionMessage {
    return {
        showListPane,
    };
});
